// App.js
import React, { useState, useEffect } from 'react';
import { Routes, 
    Route, useLocation } from 'react-router-dom';
import './App.css';


import Contact from './Contact';

import WorkoutLibrary from './WorkoutLibrary';
import Dashboard from './Dashboard';
import ClientsList from './ClientsList';
import Scheduling from './Scheduling';
import GuidedWorkoutExecutor from './GuidedWorkoutExecutor'; 
import Regenerate from './Regenerate'; 
import ClientDashboard from './ClientDashboard';
import Profile from './Profile'; 
// import Settings from './Settings'; 
import Rulesets from './Rulesets';
import Messages from './Messages';
import TrainerSearch from './TrainerSearch';
import ClientProfile from './ClientProfile';
import ExerciseTypeDetail from './ExerciseTypeDetail';
import ClientToTrainerPayments from './ClientToTrainerPayments';
import OneRepMaxTool from './OneRepMaxTool';
import TimerTool from './TimerTool';
import SchedulingAvailability from './SchedulingAvailability';
import ResultView from './ResultView';
import { UnfinishedToolsList } from './UnfinishedToolsList';

import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsOfUse } from './TermsOfUse';
import { LandingPage } from './LandingPage';
import { LoginPage } from './LoginPage';
import {  NewsArticle1, NewsArticle2, NewsArticle3, NewsArticle4,
  Article01, Article02, Article03, Article04
 } from './News';
import { AppTour } from './AppTour';
import AdminPTCStateView from './AdminPTCStateView';
import { useAuth } from './auth';
import ConceptualDemoWarning from './ConceptualDemoWarning';
import SidebarNav from './SidebarNav';
import {
  SubscriptionPage,
  HourlyRatePage,
  
  PrivacyPage,
  ManageAccountPage,
  LogoutPage
} from './Settings';
import NotificationsSettings from './NotificationSettings';

import Step1 from './steps/Step1';
import Step2 from './steps/Step2';
import StepTrainerPhone from './steps/StepTrainerPhone';
import StepTrainerSMSConsent from './steps/StepTrainerSMSConsent';
import StepTrainerTestMessage from './steps/StepTrainerTestMessage';
import Step3 from './steps/Step3';
import Step4 from './steps/Step4';
import Step5 from './steps/Step5';
import RemindersInfo from './steps/RemindersInfo';
import Step6 from './steps/Step6';

import OptInPage from './optin/OptInPage';
import OptInConfirmation from './optin/OptInConfirmation';
import SweatTextDashboard from './SweatTextDashboard';
import UnsubscribePage from './UnsubscribePage';
import { sidebarStructure, collectRoutes } from './sidebarStructure';
import ProteinIntakeCalculator from './ProteinIntakeCalculator';
import {SweatTextLandingPage} from './SweatTextLandingPage';
import StepClientName from './steps/StepClientName';
import StepNextAppointment from './steps/StepNextAppointment';
import StepInviteClient from './steps/StepInviteClient';
import {useNavigate} from 'react-router-dom';
import Footer from './Footer';

import InfoButton from './InfoButton';
import HomeButton from './HomeButton';


/*

Take a Tour 

Tools 
  SweatText Appointment Reminders [/tools/reminders]
  One Rep Max Estimator Tool [/tools/onerepmax]
  Basic Countdown Timer Tool [/tools/timer]
  Workout Library Demo [/workoutlibrary]
  Trainer Library Demo [/trainersearch]
  Guided Workout Demo [/clients/example/executeworkoutsession]
  Messages Demo [/messages]
  Appointments Demo [/clients/example/executeworkoutsession]
    Suggest New Workout Appointment Plans [/clients/example/regenerate]
    Payments [/clients/example/payments]

Articles
  SweatText Demo Released [/news]
  Timer & One Rep Max Tools Available! [/news]
  Demo Platform Released [/news]

(Always visible links)
Privacy Policy
Terms of Use
Manage Cookies

*/




// --- Main App Wrapper ---
function AppContent() {
  const { user, login } = useAuth();
    const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tourOpen, setTourOpen] = useState(() => {
    // True if we are at /tour 
    return window.location.pathname === '/tour';
  });
  const location = useLocation();

  // Get all routes under tooldemos
  const tooldemosRoutes = React.useMemo(() => {
    const tooldemosNode = sidebarStructure.home.children.tooldemos;
    return collectRoutes(tooldemosNode);
  }, []);

  // Check if current path matches any tooldemos route
  const isTooldemosRoute = tooldemosRoutes.some(route =>
    location.pathname === route ||
    (route.includes(':') && location.pathname.startsWith(route.split(':')[0]))
  );

  const handleStartTour = () => {
    setTourOpen(true);
    // also log in if not logged in 
    if (!user) {
      login({ username: 'trainer', password: '1234' });
    }
    // window.sessionStorage.setItem('ptc_tour_seen', '1');
  };


  // use useEffect to ensure that login is called when the user is not logged in
  useEffect(() => {
    if (!user && tourOpen) {
      login({ username: 'trainer', password: '1234' });
    }
  }, [tourOpen, login, user]);

  return (
    <>
      <div className="container" style={{ position: 'relative', 
            zIndex: 1 }}>

        
        
        {/* <SidebarNav sidebarOpen={sidebarOpen} 
                    setSidebarOpen={setSidebarOpen}
                    handleStartTour={handleStartTour}
                    onClose={() => setSidebarOpen(false)} /> */}



          {/* <HomeButton /> */}
          <InfoButton />


        <div
          className="main"
          style={{
            transition: 'padding-left 0.3s ease',
            paddingLeft:  '0',
            paddingRight: '60px'
    }}
        >


        
        


          {isTooldemosRoute && <ConceptualDemoWarning />}


          <AppTour open={tourOpen}
                    setSidebarOpen={setSidebarOpen}
                    onClose={() => setTourOpen(false) 
            } />



          <Routes>
          {!user && (
          <Route path="/" element={<SweatTextLandingPage />} />
          )}
          {user && (
            <Route path="/" element={<SweatTextDashboard />} />
          )} 
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/news" element={<News />} /> */}
            <Route path="/news/1" element={<NewsArticle1 />} />
            <Route path="/news/2" element={<NewsArticle2 />} />
            <Route path="/news/3" element={<NewsArticle3 />} />
            <Route path="/news/4" element={<NewsArticle4 />} />
            <Route path="/articles/1" element={<Article01 />} />
            <Route path="/articles/2" element={<Article02 />} />
            <Route path="/articles/3" element={<Article03 />} />
            <Route path="/articles/4" element={<Article04 />} />

            
          <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/about" element={<SweatTextLandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/workoutlibrary" element={<WorkoutLibrary />} />
            <Route path="/tools/onerepmax" element={<OneRepMaxTool />} />
            <Route path="/tools/proteinintake" element={<ProteinIntakeCalculator />} />
            <Route path="/tools/timer" element={<TimerTool />} />
            <Route path="/workoutlibrary" element={<WorkoutLibrary />} />
            <Route path="/rulesets" element={<Rulesets />} />
            <Route path="/clientlist" element={<ClientsList />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/trainerssearch" element={<TrainerSearch />} />
            <Route path="/clients/example/dashboard" element={<ClientDashboard />} />
            <Route path="/clients/example/queue" element={<ResultView />} />
            <Route path="/clients/example/profile" element={<ClientProfile />} />
            <Route path="/clients/example/scheduling" element={<Scheduling />} />
            <Route path="/clients/example/payments" element={<ClientToTrainerPayments />} />
            <Route path="/clients/example/regenerate" element={<Regenerate />} />
            <Route path="/clients/example/schedulingavailability" element={<SchedulingAvailability />} />
            <Route path="/clients/example/executeworkoutsession" element={<GuidedWorkoutExecutor />} />
            <Route path="/workouts/:workoutID" element={<ExerciseTypeDetail />} />
            <Route path="/tools/onerepmax" element={<OneRepMaxTool />} />
            <Route path="/tools/timer" element={<TimerTool />} />
            <Route path="/logout" element={<LoginPage />} />  
            <Route path="/tools/reminders/info" element={<RemindersInfo />} />
            <Route path="/tools/reminders/dashboard" element={<>
                        <SweatTextDashboard />
                      </>} />
            <Route path="/opt-in" element={<OptInPage />} />
            <Route path="/opt-in/confirmed" element={<OptInConfirmation />} />

            {/* Admin PTC State route */}
            {user && user.role && user.role.includes('admin') && (
              <Route path="/admin/ptcstate" element={<AdminPTCStateView />} />
            )}
            {/* Settings routes */}
            <Route path="/settings/subscription" element={<SubscriptionPage />} />
            <Route path="/settings/hourly-rate" element={<HourlyRatePage />} />
            <Route path="/settings/notifications" element={<NotificationsSettings />} />
            <Route path="/settings/privacy" element={<PrivacyPage />} />
            <Route path="/settings/account" element={<ManageAccountPage />} />
            <Route path="/settings/logout" element={<LogoutPage />} />
            <Route path="/unfinished" element={<UnfinishedToolsList />} />
            <Route path="/tools/reminders/step1" element={<Step1 />} />
            <Route path="/tools/reminders/step2" element={<Step2 />} />
            <Route path="/tools/reminders/step3" element={<Step3 />} />
            <Route path="/tools/reminders/step4" element={<Step4 />} />
            <Route path="/tools/reminders/step5" element={<Step5 />} />
            <Route path="/tools/reminders/step6" element={<Step6 />} />
            <Route path="/tools/reminders/step-trainer-phone" element={<StepTrainerPhone />} />
            <Route path="/tools/reminders/step-consent" element={<StepTrainerSMSConsent />} />
            <Route path="/tools/reminders/step-trainer-test" element={<StepTrainerTestMessage />} />
            <Route path="/tools/reminders/stepclientname" element={<StepClientName />} />
            <Route path="/tools/reminders/stepnextappointment" element={<StepNextAppointment />} />
            <Route path="/tools/reminders/stepinviteclient" element={<StepInviteClient />} />
            
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
          </Routes>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}


export default AppContent;